import { createIcon } from '@chakra-ui/react';

export const CalendarAdd = createIcon({
  displayName: 'CalendarAdd',
  viewBox: '0 0 17.143 16',
  path: (
    <path
      d="M7,11.975H8.214v1.217a.857.857,0,1,0,1.714,0V11.975h1.216a.873.873,0,0,0,.873-.858.858.858,0,0,0-.873-.858H9.929V8.979a.857.857,0,1,0-1.714,0v1.233H7a.858.858,0,0,0-.873.858.873.873,0,0,0,.873.9Zm7.995-9.938h-.873V1.662a.873.873,0,0,0-1.73,0v.374H5.768V1.662a.873.873,0,0,0-1.73,0v.374H3.149A2.651,2.651,0,0,0,.5,4.689v9.564A2.651,2.651,0,0,0,3.149,16.9H14.994a2.651,2.651,0,0,0,2.649-2.652V4.689a2.651,2.651,0,0,0-2.649-2.652Zm.935,12.216a.936.936,0,0,1-.935.936H3.149a.936.936,0,0,1-.935-.936v-7.6H15.929Z"
      transform="translate(-0.5 -0.905)"
      fill="currentColor"
    />
  ),
});
